import { getAbsoluteFileUrl } from 'src/app/helpers/utils';
function Media({ name, fileSrc, className, type }) {
  if (!fileSrc)
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? lighten(theme.palette.background.default, 0.4)
              : lighten(theme.palette.background.default, 0.02),
        }}
      >
        <img
          alt={process.env.REACT_APP_COMPANY_NAME}
          src={`assets/images/logo/${process.env.REACT_APP_COMPANY_NAME}/logo.svg`}
          className="object-contain rounded-8"
          style={{
            width: '100%',
            height: '70%',
          }}
        />
      </div>
    );

  return (
    <img
      alt={name}
      src={getAbsoluteFileUrl(fileSrc?.slice(1))}
      type={type}
      className={['rounded-8 w-full h-full object-contain object-top', className].join(' ')}
    />
  );
}

export default Media;
